import { ColumnsType } from 'antd/lib/table';
import { AddRowButton, Select, RemoveRowButton } from 'formik-antd';
import { Fragment } from 'react';
import { Row, Col, Button, Tooltip } from 'antd';
import { FaPlus } from 'react-icons/fa';
import _ from 'lodash';
import Typography from 'antd/lib/typography';
import { GrCheckmark } from 'react-icons/gr';
import { useIntl } from 'react-intl';
import { FcCancel } from 'react-icons/fc';
import { FormikProps } from 'formik';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { BannerProductListDto } from '../../../../../../shared/services/banners/dto/banner-product-list-dto';
import { CheckIsUpdateOrCreateRow } from '../../../../../../shared/common-dtos/check-is-update-or-create-row';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import { BannersListDto } from '../../../../../../shared/services/banners/dto/banners-list-dto';
import { PorductVariantSkuDto } from '../../../../../../shared/services/banners/dto/porduct-variant-sku-dto';
import { BannerTypes } from '../../../../../../shared/constants/AppEnums';
import MainUtils from 'src/shared/utils/main';
import PagedProductSelect from 'src/shared/components/paged-product-select';
import { bannersService } from '../../../../../../shared/services/banners';

// A variant's colour and size; a variant without one shows the other alone.
const variantLabel = (color?: string | null, size?: string | null) =>
  [color, size].filter(Boolean).join(' && ');

const ColumnsData = (
  formProps: FormikProps<{
    item: Array<BannerProductListDto>;
  }>,
  update: CheckIsUpdateOrCreateRow,
  bannerDetails: BannersListDto,
  mainCategoryId: string,
  productDetailsList: Array<PorductVariantSkuDto>,
  productDetailsListLodaing: boolean,
  productSelected: string,
  setProductSelected: any,
  handleCreateNewRow: Function,
  isCreateNewBannerPoductLoading: boolean,
  handleCreateNewBannerProduct: Function,
  handleRemoveNewRow: Function,
  deleteBannerProduct: (value: any) => void,
): ColumnsType<any> => {
  const { messages } = useIntl();

  const checkIsCreate = (index: number) => {
    if (update.id === index) {
      return update.createNew;
    }
    return false;
  };

  const checkIfCanCreateNewRow = () => {
    if (update.createNew) {
      return true;
    } else return false;
  };

  const createNewRowButton = () => {
    handleCreateNewRow(formProps.values.item.length);
    return;
  };

  return [
    {
      width: '7%',
      key: 'add',
      className: 'col-center',
      title: () => {
        return (
          <Tooltip title={messages['common.addNewRecord'].toString()}>
            {checkIfCanCreateNewRow() ? (
              <Button icon={<FaPlus />} type='link' />
            ) : (
              <AddRowButton
                type='link'
                name='item'
                disabled={bannerDetails?.TypeValue !== BannerTypes.Products}
                createNewRow={createNewRowButton}
                icon={<FaPlus />}
              />
            )}
          </Tooltip>
        );
      },
      ellipsis: true,
    },
    {
      title: <IntlMessages id='common.name' />,
      dataIndex: 'Name',
      width: '15%',
      key: 'Name',
      ellipsis: true,
      render: (value: any, record: BannerProductListDto, index: any) => {
        return (
          <Fragment>
            {checkIsCreate(index) ? (
              <Row className='fullContent'>
                <Col span={24}>
                  <PagedProductSelect
                    // A new main category starts the list over.
                    key={mainCategoryId}
                    name={`item[${index}].productId`}
                    fetchPage={(params) =>
                      bannersService.getPagedProductOptionsByCategoryId(
                        mainCategoryId,
                        params,
                      )
                    }
                    onSelect={(value) => setProductSelected(value)}
                  />
                </Col>
              </Row>
            ) : (
              <Typography.Text>{record?.Name}</Typography.Text>
            )}
          </Fragment>
        );
      },
    },
    {
      title: <IntlMessages id='promotions.banners.edit.colorAndSize' />,
      dataIndex: 'VariantId',
      width: '15%',
      key: 'VariantId',
      ellipsis: true,
      render: (value: any, record: BannerProductListDto, index: any) => {
        return (
          <Fragment>
            {checkIsCreate(index) ? (
              <Row className='fullContent'>
                <Col span={24}>
                  <Select
                    className='width-100'
                    loading={productDetailsListLodaing}
                    disabled={productSelected ? false : true}
                    name={`item[${index}].variantId`}
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      MainUtils.filterOptions(input, option, true)
                    }>
                    {productDetailsList?.map((item, index) => (
                      <option
                        key={item.productVariantId}
                        value={item.productVariantId}
                        label={variantLabel(item?.colorName, item?.sizeName)}>
                        {variantLabel(item?.colorName, item?.sizeName)}
                      </option>
                    ))}
                  </Select>
                </Col>
              </Row>
            ) : (
              <Typography.Text>{variantLabel(record?.Color, record?.Size)}</Typography.Text>
            )}
          </Fragment>
        );
      },
    },
    {
      title: <IntlMessages id='common.Action' />,
      className: 'col-actions',
      width: 100,
      key: 'action',
      render: (value, record: any, index) => {
        return (
          <Row justify='center'>
            <Col>
              <Tooltip
                title={
                  checkIsCreate(index) && messages['common.save'].toString()
                }>
                {checkIsCreate(index) && (
                  <Button
                    onClick={() => handleCreateNewBannerProduct(record)}
                    loading={isCreateNewBannerPoductLoading}
                    type='link'
                    icon={<GrCheckmark />}
                  />
                )}
              </Tooltip>
            </Col>

            <Col>
              <Tooltip
                title={
                  checkIsCreate(index)
                    ? messages['common.cancel'].toString()
                    : messages['common.remove'].toString()
                }>
                {checkIsCreate(index) ? (
                  <RemoveRowButton
                    name='item'
                    type='link'
                    icon={
                      <FcCancel
                        className='removeIcon'
                        onClick={() => handleRemoveNewRow()}
                      />
                    }
                    index={index}
                  />
                ) : (
                  <Button
                    onClick={() => deleteBannerProduct(record)}
                    disabled={bannerDetails?.TypeValue !== BannerTypes.Products}
                    icon={<RiDeleteBin5Line className='removeIcon' />}
                    type='link'
                    danger
                  />
                )}
              </Tooltip>
            </Col>
          </Row>
        );
      },
      ellipsis: true,
    },
  ];
};
export default ColumnsData;
